import { EmptyState } from '@/_components/EmptyState';
import { FC } from 'react';
import { EmptyDashboardProps } from './EmptyDashboard.types';
import { Flex } from '@/_components';

export const EmptyDashboard: FC<EmptyDashboardProps> = () => {
  return (
    <Flex isColumn={true} gap={16} isYCentered={true} padding={32}>
      <EmptyState description="No questionnaires found" icon="questionnaire" />
    </Flex>
  );
};
